export { default } from './getAreaBreakpoints'
export * from './getAreaBreakpoints'
